import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Motive } from '../../../../../../shared/types/systemConfiguration/motives';

export const useMotiveData = (motive?: Motive) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            extra: '',
            parent: [],
            active: true,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            name: motive?.name || '',
            parent: (motive?.parent as any) || [],
            extra: motive?.extra || '',
            active: motive?.active ?? false,
        });
    }, [motive]);

    return {
        formik,
    };
};
